import React, { Component } from "react";
import Swal from "sweetalert2";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import ContentLayout from "../../../../partials/content/ContentLayout";
import Illustration from "../../../../partials/content/Illustration";
import DialogLayout from "../../../../partials/content/DialogLayout";
import {
  deleteOutlet,
  getOutlets,
} from "../../../../services/sales/outletService";
import OutletForm from "./outletForm";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import { whatsappChat } from "../../../../utils/utils";
import withGlobalData from "../../common/withGlobalData";
class Outlets extends Component {
  state = {
    reload: this.props.globalData.reload,
    auth: {},
    open: false,
    currencies: [],
    outlets: [],
    countries: [],
    outlet: {},
    outletDetailColumn: [
      {
        header: "Email",
        field: "addressEmail",
        type: "string",
      },
      {
        header: "Thermal Printer Size",
        field: "thermalPrinterSizeName",
        type: "string",
      },
      {
        header: "Address",
        field: "address",
        type: "string",
      },
      {
        header: "Province / State",
        field: "province",
        type: "string",
      },
      {
        header: "Country",
        field: "countryName",
        type: "string",
      },
      {
        header: "Postal Code",
        field: "postalCode",
        type: "string",
      },
      {
        header: "Created At",
        field: "CreatedAt",
        type: "datetime",
      },
      {
        header: "Created By",
        field: "createdByName",
        type: "string",
      },
      {
        header: "Updated At",
        field: "UpdatedAt",
        type: "datetime",
      },
      {
        header: "Updated By",
        field: "updatedByName",
        type: "string",
      },
    ],
  };

  componentDidMount() {
    this.getOutlets();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getOutlets();
      this.setState({ reload: globalData.reload });
    }
  }

  async getOutlets() {
    const response = await getOutlets();
    const { data, auth } = response.data;
    const { outlets } = data;
    this.setState({ open: false, outlets, auth });
  }
  render() {
    const { auth, outlets, outlet, open, outletDetailColumn } = this.state;
    const { history } = this.props;
    const actionButtons = [];
    actionButtons.push({
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        this.props.history.push("/menu");
      },
    });
    if (auth.create) {
      actionButtons.push({
        title: "New Outlet",
        color: "primary",
        icon: "fas fa-plus-circle",
        onClick: () => {
          this.handleOpenDialog();
        },
      });
    }
    return (
      <React.Fragment>
        <PageSubHeader
          title="Outlet List"
          breadcrumbs={[
            { page: "/menu", title: "Menu", active: false },
            {
              page: "/sales/outlets",
              title: "Outlets",
              active: true,
            },
          ]}
          actionButtons={actionButtons}
        />
        <ContentLayout>
          {outlets.length ? (
            <CustomDataTable
              data={outlets}
              dataDetailColumns={outletDetailColumn}
              onRefreshData={() => {
                this.getOutlets();
              }}
              tableName="outlet"
              selectionMode="checkbox"
              columns={[
                {
                  selectionMode: "multiple",
                },
                {
                  header: "Outlet ID",
                  field: "ID",
                  body: null,
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Outlet Name",
                  field: "outletName",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.outletName}
                        maxLine="1"
                      />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Phone Number",
                  field: "addressPhone",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis text={rowData.addressPhone} />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "City",
                  field: "city",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis text={rowData.city} maxLine="1" />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Currency",
                  field: "currency.currencyCode",
                  body: null,
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Actions",
                  body: (rowData) => (
                    <React.Fragment>
                      {rowData.addressPhone !== "" ? (
                        <BootstrapTooltip title="Whatsapp Chat Outlet">
                          <button
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              whatsappChat(
                                rowData.addressPhone,
                                `Hi outlet ${rowData.outletName}`
                              );
                            }}
                            className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                          >
                            <i className="flaticon-whatsapp"></i>
                          </button>
                        </BootstrapTooltip>
                      ) : null}
                      <BootstrapTooltip title="Edit Outlet">
                        <button
                          type="button"
                          onClick={(event) =>
                            this.handleOpenDialogEditOutlet(event, rowData)
                          }
                          className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                      </BootstrapTooltip>
                      <BootstrapTooltip title="Outlet Point of Sales Setting">
                        <button
                          type="button"
                          onClick={(event) => {
                            history.push("/sales/outlet-setting/" + rowData.ID);
                          }}
                          className="btn btn-icon btn-label-warning btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-cash-register"></i>
                        </button>
                      </BootstrapTooltip>
                      <BootstrapTooltip title="Delete Outlet">
                        <button
                          type="button"
                          onClick={(event) =>
                            this.handleDeleteOutlet(rowData.ID)
                          }
                          className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </BootstrapTooltip>
                    </React.Fragment>
                  ),
                  sortable: false,
                },
              ]}
            />
          ) : (
            <Illustration
              imageSource="INVIFO Sales.png"
              description="Hooray! You're ready to have your first Outlet!"
              guidance="Hint: manage your outlets to simplify daily operational"
              descriptionLeftIcon="fas fa-info-circle kt-font-success"
            ></Illustration>
          )}
        </ContentLayout>
        <DialogLayout
          open={open}
          title="Outlet Form"
          onCloseDialog={this.handleCloseDialog}
          maxWIdth="md"
        >
          <OutletForm
            outlet={outlet}
            onCloseDialog={this.handleCloseDialog}
            onReloadOutlets={this.handleReloadOutlets}
          />
        </DialogLayout>
      </React.Fragment>
    );
  }

  handleDeleteOutlet = (outletID = 0) => {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Outlet ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteOutlet(outletID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            this.getOutlets();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  };

  handleOpenDialogEditOutlet = (event, outlet) => {
    this.setState({ open: true, outlet });
  };

  handleReloadOutlets = () => {
    this.getOutlets();
  };

  handleCloseDialog = () => {
    this.setState({ open: false });
  };

  handleOpenDialog = () => {
    this.setState({ outlet: {}, open: true });
  };
}

export default withGlobalData(Outlets);
